import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'lighthouse-ui';
  header: boolean = false;

  constructor(private router: Router) {}
  ngOnInit(): void {}

  showUserLogin() {
    if (this.router.url === '/' || this.router.url === '/login') {
      return false;
    } else if (this.header) {
      return false;
    } else {
      return true;
    }
  }
}
